import ".././styles/AboutUs.css";
import CoreValues from "../components/CoreValues";
import CodeOfEthics from "../components/CodeOfEthics";
import BoardmemberCard from "../components/BoardmemberCard";
import React, { useState, useEffect, useLayoutEffect } from "react";
import pccmlogo from ".././assets/pccm_logo.png"; 

import infoIcon from ".././assets/info-icon.png";
import Banner from "../components/NotificationBanner";

// --- Configuration for Google Sheets API ---
const GOOGLE_API_KEY = 'AIzaSyCLfnoX4kMuKDpNMQ9HZ2qJP28aRKNd2Hg';
const SPREADSHEET_ID = '16I9JOyUgHldKvU8AqhPl8ABxFRwBfb_mk37zbMhU1mU';
const BOD_SHEET_RANGE = 'boardOfDirectors!A:E';
const MEMBERS_SHEET_RANGE = 'boardMembers!A:D'; 

function AboutUs() {
    
    const [active, setActive] = React.useState(1);
    const SetView = (active) => {
        setActive(active);
    };

    const ActiveView = () => {
        switch (active) {
            case 1:
                return <CoreValues />;
            default:
                return <CodeOfEthics />;
        }
    };

    const [bod, setBod] = useState([]);
    const [member, setMember] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true); 
            setError(null);   

            try {
                // Fetch Board of Directors data
                const bodApiUrl = `https://sheets.googleapis.com/v4/spreadsheets/${SPREADSHEET_ID}/values/${BOD_SHEET_RANGE}?key=${GOOGLE_API_KEY}`;
                const bodResponse = await fetch(bodApiUrl);
                if (!bodResponse.ok) {
                    const errorJson = await bodResponse.json();
                    const errorMessage = errorJson.error ? errorJson.error.message : bodResponse.statusText;
                    throw new Error(`HTTP Error! Status: ${bodResponse.status} for Board of Directors - ${errorMessage}`);
                }
                const bodJsonData = await bodResponse.json();
                
                if (bodJsonData && bodJsonData.values) {
                    const bodHeaders = bodJsonData.values[0];   //Header is at the top row
                    const bodRows = bodJsonData.values.slice(1);
                    const parsedBod = bodRows.map(row => {
                        let item = {};
                        bodHeaders.forEach((header, index) => {
                            item[header.toLowerCase()] = row[index]
                        });
                        return item;
                    });
                    setBod(parsedBod);
                } else {
                    console.warn("Google Sheets API Board of Directors data not found or response is empty.", bodJsonData);
                    setBod([]);
                }

                // Fetch Members data
                const membersApiUrl = `https://sheets.googleapis.com/v4/spreadsheets/${SPREADSHEET_ID}/values/${MEMBERS_SHEET_RANGE}?key=${GOOGLE_API_KEY}`;
                const membersResponse = await fetch(membersApiUrl);
                if (!membersResponse.ok) {
                    const errorJson = await membersResponse.json();
                    const errorMessage = errorJson.error ? errorJson.error.message : membersResponse.statusText;
                    throw new Error(`HTTP Error! Status: ${membersResponse.status} for Members - ${errorMessage}`);
                }
                const membersJsonData = await membersResponse.json();

                if (membersJsonData && membersJsonData.values) {
                    const memberHeaders = membersJsonData.values[0]; //Header is at the top row
                    const memberRows = membersJsonData.values.slice(1);
                    const parsedMembers = memberRows.map(row => {
                        let item = {};
                        memberHeaders.forEach((header, index) => {
                            item[header.toLowerCase()] = row[index];
                        });
                        return item;
                    });
                    setMember(parsedMembers);
                } else {
                    console.warn("Google Sheets API Members data not found or response is empty.", membersJsonData);
                    setMember([]);
                }

            } catch (err) {
                console.error("Error fetching data:", err);
                setError(err); // Set error state
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []); // Run once on mount

    // Only scroll when loading is false and no error occurred
    useLayoutEffect(() => {
        if (!loading && !error) { 
            window.scrollTo(0, 0);
        }
    }, [loading, error]);

    // You can use bod and member states in your JSX here
    if (loading) {
        return (
            <div className="loading">
                <img src={pccmlogo} className="sml-logo" alt="pccm-logo"></img>
                <p><b>Loading About Us page...</b></p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="loading">
                <h1>⚠︎</h1>
                <p><b>Error: {error.message}</b></p>
                <div className="button-2" onClick={() => window.location.reload()}>Retry</div>
            </div>
        );
    }
   
    return (
        <div>
            <div className="container">
                <div className="aboutus-banner-container" id="banner">
                    <div className="aboutus-banner">
                        <h1>About Us</h1>
                    </div>
                </div>
                <div className="container">
                    <div className="aboutus-details">
                        <div id="aboutus-top">
                            <h2 className="section-title">Our Story</h2>
                            <h3>The PCCM is a charitable non-profit Filipino-Canadian organization since the 1990s.</h3>
                        </div>
                        <div id="aboutus-story">
                            <p> The Philippine Canadian Centre of Manitoba (PCCM) traces its origins to the late 1980s when the Filipino-Canadian 
                                community in Winnipeg embarked on a journey to establish a larger cultural hub. Initially housed in a modest facility at the corner of Juno Street and 
                                McDermot Avenue, discussions between community leaders and city officials in 1989 led to the proposal for a larger and dedicated Philippine Cultural Centre. 
                                Negotiations with the City of Winnipeg culminated in a 50-year lease agreement for a 2.96-acre plot at a nominal cost of $1 per year, despite adjustments to the project scope due to logistical challenges.
                                Following these negotiations, the Philippine Centre Fundraising Committee was formed, later evolving into the Philippine Foundation of Manitoba, Inc., and ultimately incorporating as the Philippine Canadian Centre of Manitoba, 
                                Inc. in November 1998. Since its inception, PCCM has been a cornerstone of cultural identity and community pride, celebrating many years of enriching Filipino-Canadian heritage and serving as a vibrant hub for cultural, 
                                social, and educational activities in Winnipeg and Manitoba.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="container" id="our-mission-container">
                    <div className="our-mission">
                        <h2>Our Mission</h2>
                        <p id="mission-description">
                            The Philippine Canadian Centre of Manitoba, Inc. (PCCM) supports and/or defends core values in
                            our work and promotes them as we continue serving our members, the Filipino-Canadian community
                            and beyond.
                            We seek to nurture the spirit of a non-profit organization by recognizing and celebrating successes and learning from valuable failures.
                        </p>
                        <div className="mission-selector">
                            <input type="radio" name="answer"id="core-values-button" onClick={() => {SetView(1)}} defaultChecked/> <label for="core-values-button"><h3>Core Values</h3></label>
                            <input type="radio" name="answer"id="code-of-ethics-button" onClick={() => SetView(2)}/><label for="code-of-ethics-button"><h3>Code of Ethics</h3></label>
                        </div>
                        {ActiveView()}
                    </div>
                    <div id="boardmembers"></div>
                </div>
                <div className="container boardmember-container">
                    <h2>Members of the Governing Board</h2>
                    <h3 className="member-title">Board of Directors</h3>
                    <div id="boardmembers-list">
                        {bod.length > 0 ? (
                            bod.map((boardMember) => (
                                <BoardmemberCard
                                    key={boardMember.id}
                                    name={boardMember.name}
                                    position={boardMember.position}
                                    description={boardMember.description}
                                    image={boardMember.image}
                                />
                            ))
                        ) : (
                            <p>No board of directors found.</p>
                        )}
                    </div>
                    <h3 className="member-title">Board Members</h3>
                    <div id="boardmembers-list">
                        {member.length > 0 ? (
                            member.map((individualMember) => (
                                <BoardmemberCard
                                    key={individualMember.id}
                                    name={individualMember.name}
                                    position="Board Member"
                                    description={individualMember.description}
                                    image={individualMember.image}
                                />
                            ))
                        ) : (
                            <p>No members found.</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AboutUs;